import { SxProps, Theme } from '@mui/material/styles';

/**
 * Merge a component's base styles with a caller-provided `sx` (caller wins).
 * Style-only primitives should be `styled()` components instead — sx merging
 * comes free there; use this only in components with structural props.
 */
const mergeSx = (
  base: SxProps<Theme>,
  sx: SxProps<Theme> | undefined,
): SxProps<Theme> =>
  [
    ...(Array.isArray(base) ? base : [base]),
    ...(Array.isArray(sx) ? sx : [sx]),
  ] as SxProps<Theme>;

export default mergeSx;
